/**
 * Video Modal Module
 * File: video-modal.js
 * Gestisce apertura/chiusura della modal video globale (#video-modal).
 * Usa event delegation su [data-video-trigger] — funziona anche su contenuti caricati dinamicamente.
 */

const VIDEO_ID_PATTERN = /^[A-Za-z0-9_-]+$/; // Semplice pattern per ID video (YouTube/Vimeo) - può essere migliorato se necessario

const VideoModal = {
    modal: null,
    iframe: null,
    title: null,
    closeBtn: null,
    lastTrigger: null,

    init() {
        this.modal = document.getElementById('video-modal');
        if (!this.modal) return;

        this.iframe   = document.getElementById('video-modal-iframe');
        this.title    = document.getElementById('video-modal-title');
        this.closeBtn = this.modal.querySelector('[data-video-modal-close]');

        document.addEventListener('click', (e) => {
            const trigger = e.target.closest('[data-video-trigger]');
            if (trigger) this._open(e, trigger);
        });

        this.closeBtn.addEventListener('click', () => this._close());

        this.modal.addEventListener('click', (e) => {
            if (e.target === this.modal) this._close();
        });

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.modal.classList.contains('is-open')) {
                this._close();
            }
        });
    },

    _open(e, trigger) {
        e.preventDefault();

        const provider = trigger.dataset.videoProvider || '';
        const videoId  = trigger.dataset.videoId || '';
        const title    = trigger.dataset.videoTitle || '';

        if (!VIDEO_ID_PATTERN.test(videoId)) return;

        const embedUrl = this._buildEmbedUrl(provider, videoId);
        if (!embedUrl) return;

        this.iframe.src         = embedUrl;
        this.iframe.title       = title;
        this.title.textContent  = title;

        this.modal.classList.add('is-open');
        this.modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('video-modal-open');

        this.lastTrigger = trigger;
        this.closeBtn.focus();
    },

    _close() {
        this.iframe.src = '';
        this.modal.classList.remove('is-open');
        this.modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('video-modal-open');

        if (this.lastTrigger) {
            this.lastTrigger.focus();
            this.lastTrigger = null;
        }
    },

    _buildEmbedUrl(provider, videoId) {
        switch (provider) {
            case 'youtube':
                return `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0`;
            case 'vimeo':
                return `https://player.vimeo.com/video/${videoId}?autoplay=1`;
            default:
                return '';
        }
    },
};

export default VideoModal;
